export const reservedUsernames = [
  "about",
  "account",
  "admin",
  "affiliate",
  "api",
  "billing",
  "community",
  "contact",
  "cookies",
  "dahlini",
  "dashboard",
  "delete",
  "edit",
  "gear",
  "help",
  "legal",
  "login",
  "map",
  "mod",
  "moderator",
  "new",
  "official",
  "partner",
  "partners",
  "privacy",
  "profile",
  "recover",
  "register",
  "resources",
  "search",
  "security",
  "settings",
  "sponsor",
  "spots",
  "staff",
  "support",
  "team",
  "terms",
  "verified",
  "weather"
] as const;

const reservedUsernameSet = new Set<string>(reservedUsernames);
const usernamePattern = /^[a-z0-9][a-z0-9._-]{2,29}$/;
const blockedUsernameExact = new Set([
  "ass",
  "bastard",
  "bitch",
  "cock",
  "cunt",
  "dick",
  "fuck",
  "nigger",
  "pussy",
  "retard",
  "shit",
  "slut",
  "spic",
  "tranny",
  "whore"
]);
const blockedUsernameAffixes = [
  "asshole",
  "bitch",
  "cunt",
  "fuck",
  "heilhitler",
  "killjews",
  "nigger",
  "retard",
  "shit",
  "tranny",
  "whitepower"
];
const moderationCharacterMap: Record<string, string> = {
  "0": "o",
  "1": "i",
  "3": "e",
  "4": "a",
  "5": "s",
  "7": "t",
  "8": "b",
  "9": "g"
};

export function normalizeUsername(value: string) {
  return value.trim().toLowerCase();
}

export function validateUsername(value: string) {
  const username = normalizeUsername(value);

  if (!usernamePattern.test(username)) {
    return "Use 3-30 lowercase letters, numbers, dots, underscores, or hyphens.";
  }

  if (reservedUsernameSet.has(username)) {
    return "That username is reserved by Dahlini.";
  }

  if (isBlockedUsername(username)) {
    return "Choose a different username.";
  }

  return null;
}

export function usernameToInternalEmail(value: string) {
  return `${normalizeUsername(value)}@accounts.dahlini.invalid`;
}

export function isBlockedUsername(value: string) {
  const compactUsername = normalizeUsername(value)
    .replace(/[01345789]/g, (character) => moderationCharacterMap[character])
    .replace(/[._-]/g, "")
    .replace(/(.)\1{2,}/g, "$1");

  if (blockedUsernameExact.has(compactUsername)) {
    return true;
  }

  return blockedUsernameAffixes.some(
    (blockedValue) => compactUsername.startsWith(blockedValue) || compactUsername.endsWith(blockedValue)
  );
}
